let modalClose = document.querySelector(".product-modal-wrapper .close-icon");
let productModal = document.querySelector(".product-modal-wrapper");
let addFreeProductButton = document.querySelector("button.add-free-gift");
let modalTrigger = document.querySelector(".selected-product-image-wrapper");
modalClose.addEventListener("click", () => {
  productModal.style.display = "none";
});
addFreeProductButton.addEventListener("click", () => {
  productModal.style.display = "none";
});
modalTrigger.addEventListener("click", (e) => {
  e.preventDefault();
  productModal.style.display = "block";
});


let addButton = document.querySelectorAll("button.add-product-button");
let freeProductStatus = document.querySelectorAll("span.selected-num");
let freeProductImage = document.querySelectorAll("img.free-product-image");
let popupFreeProductImageContainer = document.querySelector(".free-product-image-wrapper");

let mainProductTrigger = document.querySelector('.main-product-image');
let freeProductTrigger = document.querySelector('.selected-product-image-wrapper');

let selectButtonTrigger = document.querySelector('.select-free-product');
let selectButtonFreeImage = document.querySelector('.selected-product-image-wrapper img.free-product-image');
let freeImageText = document.querySelector('.selected-product-image-wrapper span.free-image');





let freeProductAdded = false;

addButton.forEach((button) => {
  button.addEventListener("click", (e) => {
    e.preventDefault();

    button.classList.toggle("Selected");
    

    if (button.classList.contains("Selected")) {
          freeProductImage.forEach((image)=>{
              image.setAttribute("src", `${button.parentElement.dataset.productImage}`);
          });
          freeProductAdded = true;
          popupFreeProductImageContainer.style.display = "flex";
          selectButtonTrigger.style.display = "none";
          selectButtonFreeImage.style.display = "block";
          freeImageText.style.display = "block";
          addFreeProductButton.classList.add("product-added");
          addFreeProductButton.removeAttribute("disabled");
          addFreeProductButton.dataset.freeproduct = `${button.dataset.productid}`;
          freeProductTrigger.dataset.freeproduct = `${button.dataset.productid}`;


document.getElementById('mainprice').innerHTML = `${button.dataset.productprice}`;
      
          freeProductStatus.forEach((el)=> {
            el.innerText = "1";
            
          });
          addToCart(true);
      
        } else {
          freeProductAdded = false;
          popupFreeProductImageContainer.style.display = "none";
          selectButtonTrigger.style.display = "block";
          selectButtonFreeImage.style.display = "none";
          freeImageText.style.display = "none";
          addFreeProductButton.setAttribute("disabled", true);
          addFreeProductButton.classList.remove("product-added");
          addFreeProductButton.dataset.freeproduct = "";
          freeProductTrigger.dataset.freeproduct = "";
          freeProductStatus.forEach((el)=> {
            el.innerText = "0";
          });
          addToCart(false);
        }

addButton.forEach((selectbutton) => {
      if (selectbutton != button) {
          selectbutton.toggleAttribute("disabled");
          selectbutton.classList.remove("Selected");
        }     
        if (selectbutton.classList.contains("Selected")) {
          selectbutton.innerText = "Remove";
        } else {
          selectbutton.innerText = "Add";
          
        }
    }); 
  });
});

  

function addToCart(call) {
  if (call) {
    let atcButton = document.querySelector(".product-form__cart-submit");
atcButton.addEventListener('click', (event)=>{
    event.preventDefault();
    let formData = {
     'items': [{
      'id': freeProductTrigger.dataset.freeproduct,
      'quantity': 1
      },
      {
        'id': mainProductTrigger.dataset.actualproduct,
        'quantity': 1
      }]
    };
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      window.location.href = '/cart';
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  
});
  }else{
    return "";
  }
  

}

